import { Directive, Input } from '@angular/core';

@Directive({
  selector: 'base-form'
})
export class BaseForm {

  public title: string;
  @Input() inserimento: boolean;
  public titlePrincipal: string;
  @Input() wizard: boolean;

  setTitlePrincipal(titlePrincipal: string) {
    this.titlePrincipal = titlePrincipal;
  }

  setTitle(title: string) {
    this.title = title;
  }

  isInserimento(valueInserimento: boolean) {
    this.inserimento = valueInserimento;
  }

  setWizard(wizard: boolean) {
    this.wizard = wizard;
  }

}
